module.exports = __webpack_public_path__ + "img/edge_activites_plongee.13185150.svg";